import React from 'react'
import Profile from '../components/profile/Profile'

export default function ProfilePage() {
  return (
    <div>
      <Profile/>
    </div>
  )
}
